export const setUnreadNoteCount = (note_count) => async(dispatch) => {
    dispatch({type: "COUNT_NOTE", noteCount: note_count})
}
export const setNoteData = (note_data) => async(dispatch) => {
  dispatch({type: "NOTE_DATA", noteData: note_data})
}